import React from 'react';
import ConfirmButton from "../ConfirmButton/ConfirmButton";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { useStyles, useTranslations } from "examsbook-react-sdk/custom-hooks";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";

/**
 * SubmitButton button.
 * @param props
 * @returns {string}
 * @constructor
 */
function SubmitButton(props) {
    const { mode, viewMode, hideSubmitButton, quizId } = props;
    const t = useTranslations();
    const classes = useStyles(styles)();
    const navigate = useNavigate();
  //window.navigateState(window.location.href);

    window.onpopstate = () => {
        if (!viewMode) {
            confirmAlert({
                title: 'Are you sure to quit this quiz',
                message: 'Are you sure to do this.',
                buttons: [
                    {
                        label: 'Yes',
                        onClick: () => navigate("/my-app/tests")
                    },
                    {
                        label: 'No',
                        onClick: () => navigate(1)
                    }
                ]
            });
        } else {
            navigate('/my-app/tests/result/' + quizId);
        }
    };


    function handleClickOnYes() {
        props.submitQuiz();
        reactGaEvent("quiz", "Confirm Submit");
    }

    function handleClickOnNo() {
        reactGaEvent("quiz", "Not Confirm For Submit");
    }

    function goToAllTest() {
        navigate('/my-app/tests');
    }

    return (
        <React.Fragment>
            {viewMode ? <div className={classes.submit}>
                    <button onClick={goToAllTest}>{t('Next Quiz')}</button>
                </div> :
                <div className={(hideSubmitButton ? classes.hideOnDesktop : '') + ' ' + classes.submit}>
                    <ConfirmButton mode={mode} text={t("Submit")}
                                   clickOnYes={handleClickOnYes}
                                   clickOnNo={handleClickOnNo}/>
                </div>}
        </React.Fragment>
    );
}

const styles = theme => ({
    submit: {
        float: 'right',
        lineHeight: '33px',
        marginRight: 5,
        color: '#fff',
        '& button': {
            display: 'inline-block',
            padding: '14px 30px',
            borderRadius: 3,
            color: '#fff',
            fontSize: '14px',
            fontWeight: 500,
            backgroundColor: '#5df2d630',
            lineHeight: '10px',
            height: 'auto',
            border: 0,
            cursor: 'pointer',
            textAlign: 'center',
            position: 'relative',
            boxShadow: 'none',
            '&:hover': {
                background: '#5df2d6',
                '@media (max-width: 767px)': {
                    background: '#12a188',
                }
            }
        },
        '@media (max-width:767px)': {
            width: 'auto',
            '& button': {
                padding: '10px 15px',
            }
        }
    },
    hideOnDesktop: {
        '@media (max-width:767px)': {
            display: 'inline-block',
        }
    }
});
export default SubmitButton;
